// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectDetails_root__rPUkx","hero":"ProjectDetails_hero__fGycW","detailsSection":"ProjectDetails_detailsSection__j9_dA"};